import React, { useEffect } from "react";
import "./styled.css";
//redux
import { connect } from "react-redux";
//tags
import MetaTags from "react-meta-tags";
//service
import { setAdminPlusRankingPoints } from "../../../utils/service/ranking";

function MainStage(props) {
  function pointAction(type) {
    setAdminPlusRankingPoints(
      type,
      props.state.user.registration,
      "c90a159e-e538-43d3-a66b-82292586912f"
    );
  }

  useEffect(() => {
    document.getElementById("title-mainStage").focus();
    props.loadingUserOff();
  }, []);
  return (
    <section className="section-mainStage" id="section-mainStage">
      <MetaTags>
        <title>Digital Lovers Festival - Página Palco Principal</title>
      </MetaTags>
      <a id="title-mainStage" className="title-home" tabIndex={12}>
        Página Palco Principal
      </a>
      <div className="div-cards-talent">
        <div className="card-talent">
          <a className="title-card-talent" id="title-card-talent" tabIndex={13}>
            Vídeo de Abertura
          </a>
          <video
            width={250}
            controls
            tabIndex={14}
            onPlay={() => pointAction("PALCOPRINCIPALABERTURA")}
          >
            <source src="https://s3.us-east-1.amazonaws.com/bucket.aws.private/hall_83778/PALCO_PRINCIPAL/DIGITAL%20LOVERS__ABERTURA%20RICARDO.mp4" />
          </video>
        </div>

        <div className="card-talent">
          <a className="title-card-talent" id="title-card-talent" tabIndex={15}>
            Organograma
          </a>
          <video
            width={250}
            controls
            tabIndex={16}
            onPlay={() => pointAction("PALCOPRINCIPALORGANOGRAMA")}
          >
            <source src="https://s3.us-east-1.amazonaws.com/bucket.aws.private/hall_83778/ACESSIBILIDADE/PALCO%20PRINCIPAL/organograma.mp4" />
          </video>
        </div>

        {/* <div className="card-talent">
          <a className="title-card-talent" id="title-card-talent" tabIndex={13}>
            EVP
          </a>
          <video
            width={250}
            controls
            tabIndex={14}
            onPlay={() => pointAction("PALCOPRINCIPALEVP")}
          >
            <source src="https://s3.us-east-1.amazonaws.com/bucket.aws.private/hall_83778/PALCO_PRINCIPAL/EVP.mp4" />
          </video>
        </div>

        <div className="card-talent">
          <a className="title-card-talent" id="title-card-talent" tabIndex={15}>
            Princípios de Liderença
          </a>
          <video
            width={250}
            controls
            tabIndex={15}
            onPlay={() => pointAction("PALCOPRINCIPALPRINCIPIOSDELIDERANCA")}
          >
            <source src="https://s3.us-east-1.amazonaws.com/bucket.aws.private/hall_83778/PALCO_PRINCIPAL/VIDEO%20PRINCIPIOS%20DE%20LIDERAN%C3%87A%20-%20COM%20LEGENDA.mp4" />
          </video>
        </div> */}

        {/* <div className="card-talent">
          <a className="title-card-talent" id="title-card-talent" tabIndex={15}>
            Vídeo do Ricardo
          </a>
          <video
            width={250}
            controls
            tabIndex={17}
            onPlay={() => pointAction("PALCOPRINCIPALVIDEODORICARDO")}
          >
            <source src="https://s3.us-east-1.amazonaws.com/bucket.aws.private/hall_83778/PALCO_PRINCIPAL/DIGITAL%20LOVERS__ABERTURA%20RICARDO.mp4" />
          </video>
        </div> */}
      </div>
    </section>
  );
}

const mapStateToProps = function (state) {
  return { state: state };
};

const mapDispatchToProps = function (dispatch) {
  return {
    loadingUserOff: (data) => {
      return dispatch({ type: "LOGIN_NAVIGATION_OFF", data });
    },
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(MainStage);
